// extracted by mini-css-extract-plugin
export default {"searchBarContainer":"admin_search_bar_searchBarContainer__sY170"};